<div class="row">
    <form focusInvalidInput [formGroup]="actuForm" (ngSubmit)="validate()" class="col-sm-12">
        <div class="row">
            <div class="col-sm-12" style="display: flex; justify-content: space-between;">
                <h3 class="col-sm-6">Actualité SACHA</h3>
                <div class="col-sm-6" style="justify-content: space-between;">

                    <button class="pull-right" color="warn" mat-raised-button type="button" (click)="onLeave()">
                        <mat-icon>cancel</mat-icon> Fermer
                    </button>

                    <button [color]="'success'" mat-raised-button
                        type="submit"
                        [matTooltip]="'INVALID' === this.actuForm.status ? lenghtError : 'Enregistrer'">
                        Enregistrer
                    </button>
                </div>
            </div>
        </div>     
        <mat-card class="container d-flex col-md-12 text-center">
            <div class="row col-sm-4 align-items-center">
                <div class="data-class col-sm-12">
                    <div class="header-class">
                        Saisie de l’actualité
                    </div>
                    <div style="padding-left: 0px;padding-top: 0.1em;">
                        <mat-form-field class="full-width">
                            <mat-label style="margin-left: 5px;">Actualité en markdowm</mat-label>
                            <textarea matInput name="actu" cdkTextareaAutosize cdkAutosizeMinRows="25"
                                cdkAutosizeMaxRows="25" style="background-color: white;"
                                formControlName="actu"></textarea>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <div class="data-class d-flex flex-wrap col-md-8 align-items-center">
                <div class="col-md-6 grid-title border font-weight-bold">
                    Entrez
                </div>           
                <div class="col-md-6 grid-title border font-weight-bold">
                    Pour obtenir :
                </div>

                <div class="col-md-6 grid-title border">
                    *Italique*
                </div>           
                <div class="col-md-6 grid-title border">
                    <i>Italique</i>
                </div>

                <div class="col-md-6 grid-title border">
                    **Gras**
                </div>           
                <div class="col-md-6 grid-title border">
                    <b>Gras</b>
                </div>

                <div class="col-md-6 grid-title border">
                    # Titre 1 (jusqu’à Titre 6 avec 6 #)
                </div>           
                <div class="col-md-6 grid-title border">
                    <h1>Titre 1</h1> (jusqu’à Titre 6 avec 6 #)
                </div>

                <div class="col-md-6 grid-title border">
                    ## Titre 2 (jusqu’à Titre 6 avec 6 #)
                </div>           
                <div class="col-md-6 grid-title border">
                    <h2>Titre 2</h2> (jusqu’à Titre 6 avec 6 #)
                </div>

                <div class="col-md-6 grid-title border">
                    [lien](http://a.com)
                </div>           
                <div class="col-md-6 grid-title border">
                    <a href="http://a.org">Lien</a>
                </div>

                <div class="col-md-6 grid-title border">
                    - List<br>
                    - List<br>
                    - List<br>
                </div>
                <div class="col-md-6 grid-title border text-left">
                    <ul>
                        <li>List</li>
                        <li>List</li>
                        <li>List</li>
                    </ul>
                </div>
        
                <div class="col-md-6 grid-title border">
                    1) Un<br>
                    2) Deux<br>
                    3) Trois<br>
                </div>
                <div class="col-md-6 grid-title border text-left">
                    <ol>
                        <li>Un</li>
                        <li>Deux</li>
                        <li>Trois</li>
                    </ol>
                </div>

                <div class="col-md-6 grid-title border">
                    Ligne horizontale<br>
                    ---
                </div>           
                <div class="col-md-6 grid-title border">
                    Ligne horizontale<br>
                    <hr>
                </div>

                <div class="col-md-6 grid-title border">
                    ![Texte pour malvoyants et lien cassé](/assets/imgs/capsuleVeoliaRVB.png "Titre de l'image au survol de la souris")
                </div>           
                <div class="col-md-6 grid-title border">
                    <img src="/assets/imgs/capsuleVeoliaRVB.png" height="50%" width="50%" alt="Texte pour malvoyants et lien cassé" title="Titre de l'image au survol de la souris">
                </div>

                <div class="col-md-6 grid-title border">
                    Image lien<br>
                    [![Texte pour liseuse de malvoyants ou lien cassé](/assets/imgs/capsuleVeoliaRVB.png "Titre de l'image au survol de la souris")](http://a.com)
                </div>           
                <div class="col-md-6 grid-title border">
                    Image lien<br>
                    <a href="http://a.com"><img src="/assets/imgs/capsuleVeoliaRVB.png " height="50%" width="50%" alt="Texte pour malvoyants et lien cassé" title="Titre de l'image au survol de la souris"></a>
                </div>
            </div>
        </mat-card>
        <div class="row">
            <mat-card class="col-sm-12">
                <div class="data-class">
                    <mat-label>Prévisualisation du bandeau d’accueil :</mat-label>
                    <mat-expansion-panel expanded="true" class ="panel">
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            <h5>Actualités achats</h5>
                          </mat-panel-title>
                          <mat-panel-description >
                            Bienvenue sur votre outil SACHA
                          </mat-panel-description>
                        </mat-expansion-panel-header>
                        <markdown
                            [data]="actuForm.get('actu').value + ''">
                        </markdown>
                        <div class="containerButton">
                            <ng-container *ngFor="let btn of buttonsFormArray.controls">
                                <div *ngIf="btn && btn.get('btnTitle').value">
                                    <a mat-button [disabled]="!btn.get('btnURL').value" href="{{btn.get('btnURL').value}}" target="_blank" rel="noopener">
                                        <button type="button" [disabled]="!btn.get('btnURL').value" 
                                        [ngClass]="!btn.get('btnURL').value ? 'disabbgwhite' : 'bgwhite'" class="action-button" mat-raised-button>
                                        {{btn.get('btnTitle').value}}</button></a>
                                </div>
                            </ng-container>
                        </div>
                        </mat-expansion-panel>
                </div>
            </mat-card>
            <ng-container formArrayName="buttons">
                <ng-container *ngFor="let button of buttonsFormArray.controls; let i = index" [formGroupName]="i">  
                    <mat-card class="col-md-3">

                                    
                    <div class="data-class col-md-12">
                        <div class="header-class">
                            Bouton {{i + 1}}
                        </div>
                        <mat-form-field class="full-width">
                            <mat-label style="margin-left: 5px;">Titre</mat-label>
                            <input matInput name="btnTitle" formControlName="btnTitle"/>
                            <mat-error *ngIf="button && button.get('btnTitle').hasError('maxlength')">
                                Nombre maximum de caractère dépassé ({{maxTitle}} maximum).
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="full-width">
                            <mat-label style="margin-left: 5px;">URL</mat-label>
                            <input matInput name="btnURL" formControlName="btnURL"/>
                            <mat-error *ngIf="button && button.get('btnURL').hasError('maxlength')">
                                Nombre maximum de caractère dépassé ({{maxURL}} maximum).
                            </mat-error>
                        </mat-form-field>

                        <button [color]="'warn'" mat-raised-button type="button" (click)="delButton(i)" style="margin-bottom: 1em;">
                            Supprimer le bouton {{i + 1}}
                        </button>
                    </div>
                </mat-card>
                </ng-container>
            </ng-container>
        </div>
        <button [color]="'success'" mat-raised-button type="button" (click)="addButton()">
            Ajouter un bouton
        </button>
    </form>
</div>